var m = require('mithril');
var formGroup = require('../formGroup');

var component = {};

component.view = function view (vnode) {
  return m(formGroup, [
    m('label', {for: (vnode.attrs.field.id || 'text') + '-input'}, vnode.attrs.field.name),
    m('input.form-control', {
      id: (vnode.attrs.field.id || 'text') + '-input', 
      type:'text',
      autocomplete: 'off',
      spellcheck: false,
      autocorrect: 'off',
      oninput: function(ev){vnode.attrs.prop(ev.target.value)},
      value: vnode.attrs.prop(),
    })
  ]);
};

module.exports = component;
